import $ from 'jquery';
import { addNotification } from './notifications';

export const addToCart = id => {
    $.ajax({
        url: tromplo.ajax_url,
        method: 'POST',
        data: {
            action: 'add_to_cart',
            product_id: id,
            quantity: 1,
        },
    })
        .done(response => {
            if (response['status'] === 'success') {
                addNotification(response['message']);
                $(document.body).trigger('added_to_cart');

            } else if (response['status'] === 'warning') {
                addNotification(response['message'], 'warning');
            } else {
                addNotification(response['message'], 'error');
            }
           
        })
        .fail(response => {
            addNotification('Error. Try again later.', 'error');
        });
};